import Completable from './Completable';

/**
 * Represents a new Project. This mirrors the database version of a Project
 * completely.
 */
export default class Project extends Completable {}
